<template>
  <span
      :class="[$style.icon, $style['icon-' + icon]]"
  ></span>
</template>

<script>
export default {
  name: "icon",
  props: {
    icon: { type: String }
  }
};
</script>

<style module lang="scss">
@import "../../style/modules/icomoon.module";
</style>
